import type { StepConfig } from "@portal/components/multiform/types";
import { AdditionalInfoStep } from "../../../../../agent/account/create/steps/additional-info/AdditionalInfoStep";
import { AdditionalInfoSummary } from "../../../../../agent/account/create/steps/additional-info/AdditionalInfoSummary";
import type { AdminCombinedFormData } from "../../schema";

export const additionalInfoStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "additionalInfo",
	label: "Additional Info",
	fieldPaths: ["account.additionalInfo"],
	component: AdditionalInfoStep,
	summaryComponent: AdditionalInfoSummary,
};
